// AuthContext.js
import React, { createContext, useContext, useState } from "react";
import { io } from "socket.io-client";
import { baseUrl } from "../config/config";

const AuthContext = createContext();
let userData = {};
let socket = {};

const user_info = localStorage.getItem("user_info");
if (user_info) {
  userData = JSON.parse(user_info);
  socket = io(baseUrl + `?user_id=${userData.id}`);
}

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(userData);

  const START_SOCKET_FORCEFULLY = (user_id) => {
    socket = io(baseUrl + `?user_id=${user_id}`);
  };

  const STOP_SOCKET_FORCEFULLY = () => {
    socket.disconnect();
  };

  const collection = {
    socket,
    userInfo,
    setUserInfo,
    START_SOCKET_FORCEFULLY,
    STOP_SOCKET_FORCEFULLY,
  };

  return (
    <AuthContext.Provider value={collection}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
